export type ThemeMode = 'light' | 'dark';

const THEME_STORAGE_KEY = 'tbc-theme-mode';
const THEME_EVENT_NAME = 'tbc-theme-change';

export const getThemePreference = (): ThemeMode => {
  const storedValue = window.localStorage.getItem(THEME_STORAGE_KEY);
  return storedValue === 'dark' ? 'dark' : 'light';
};

export const applyThemePreference = (mode: ThemeMode) => {
  document.body.classList.toggle('tbc-theme-dark', mode === 'dark');
  document.body.classList.toggle('tbc-theme-light', mode === 'light');
  document.documentElement.setAttribute('data-theme', mode);
};

export const setThemePreference = (mode: ThemeMode) => {
  window.localStorage.setItem(THEME_STORAGE_KEY, mode);
  applyThemePreference(mode);
  window.dispatchEvent(new CustomEvent<ThemeMode>(THEME_EVENT_NAME, { detail: mode }));
};

export const subscribeThemePreference = (callback: (mode: ThemeMode) => void) => {
  const listener = (event: Event) => {
    callback((event as CustomEvent<ThemeMode>).detail);
  };

  window.addEventListener(THEME_EVENT_NAME, listener);
  return () => window.removeEventListener(THEME_EVENT_NAME, listener);
};
